import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import linkup from '@/views/linkup.vue'


const routes = [


  {
    path: '/contact/',
    name: 'contact',
    component: HomeView
  },
  {
    path: '/',
    name: 'linkup',
    component: linkup
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
